import request from "../../untils/request.js"


export const drugStatistics = (params) => {
    return request.post("/outpatient/boss/drugReport", params )
}